var React = require('react');

function Sternchen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40.51 48.57L14.16 74.92L10.89 71.65L37.24 45.3H0V40.51H37.24L10.89 14.16L14.16 10.89L40.51 37.24V0H45.3V37.24L71.65 10.89L74.92 14.16L48.57 40.51H85.81V45.3H48.57L74.92 71.65L71.65 74.92L45.3 48.57V85.81H40.51V48.57Z","fill":"black"}));
}

Sternchen.defaultProps = {"width":"86","height":"86","viewBox":"0 0 86 86","fill":"none"};

module.exports = Sternchen;

Sternchen.default = Sternchen;
